import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Modal, Form } from "react-bootstrap";
import ReceptionistHeader from "../common/ReceptionistHeader";
import Footer from "../common/Footer";
import { baseUrl } from "../../Utility/constants";

const ManageInquiry = () => {
  const [inquiries, setInquiries] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentInquiry, setCurrentInquiry] = useState({});
  const [isEdit, setIsEdit] = useState(false);

  const userId = localStorage.getItem("userID");
  const apiUrl = `${baseUrl}/api/Receptionist`;

  // Fetch inquiries
  const fetchInquiries = async () => {
    try {
      const response = await axios.get(apiUrl);
      setInquiries(response.data);
    } catch (error) {
      toast.error("Failed to fetch inquiries");
    }
  };

  useEffect(() => {
    fetchInquiries();
  }, []);

  // Handle modal open/close
  const handleShowModal = (inquiry = {}) => {
    setCurrentInquiry(inquiry);
    setIsEdit(!!inquiry.id);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setCurrentInquiry({});
    setShowModal(false);
  };

  // Handle form submission
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const inquiryData = {
      ...currentInquiry,
      createdBy: userId,
      updatedBy: userId,
      createdOn: currentInquiry.createdOn || new Date().toISOString(),
      updatedOn: new Date().toISOString(),
      isActive: true,
      status:'PENDING'
    };

    try {
      if (isEdit) {
        await axios.put(`${apiUrl}/${currentInquiry.id}`, inquiryData);
        toast.success("Inquiry updated successfully!");
      } else {
        await axios.post(apiUrl, inquiryData);
        toast.success("Inquiry added successfully!");
      }
      fetchInquiries();
      handleCloseModal();
    } catch (error) {
      toast.error("Failed to save inquiry");
    }
  };

  // Handle delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this inquiry?")) {
      try {
        await axios.delete(`${apiUrl}/${id}`);
        toast.success("Inquiry deleted successfully!");
        fetchInquiries();
      } catch (error) {
        toast.error("Failed to delete inquiry");
      }
    }
  };

  return (
    <>
      <ReceptionistHeader />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Manage Inquiries</h2>
          <Button variant="primary" onClick={() => handleShowModal()}>
            Add Inquiry
          </Button>
        </div>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Student Name</th>
              <th>Class</th>
              <th>Stream</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {inquiries.map((inquiry, index) => (
              <tr key={inquiry.id}>
                <td>{index + 1}</td>
                <td>{inquiry.studentName}</td>
                <td>{inquiry.class}</td>
                <td>{inquiry.stream}</td>
                <td>{inquiry.phone}</td>
                <td>{inquiry.email}</td>
                <td>{inquiry.status}</td>
                <td>
                  <Button
                    variant="warning"
                    size="sm"
                    onClick={() => handleShowModal(inquiry)}
                  >
                    Edit
                  </Button>{" "}
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(inquiry.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Footer />
      <ToastContainer />

      {/* Modal for Add/Edit */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit Inquiry" : "Add Inquiry"}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleFormSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Student Name</Form.Label>
              <Form.Control
                type="text"
                value={currentInquiry.studentName || ""}
                onChange={(e) =>
                  setCurrentInquiry({ ...currentInquiry, studentName: e.target.value })
                }
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Class</Form.Label>
              <Form.Control
                type="text"
                value={currentInquiry.class || ""}
                onChange={(e) =>
                  setCurrentInquiry({ ...currentInquiry, class: e.target.value })
                }
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Stream</Form.Label>
              <Form.Control
                type="text"
                value={currentInquiry.stream || ""}
                onChange={(e) =>
                  setCurrentInquiry({ ...currentInquiry, stream: e.target.value })
                }
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="text"
                value={currentInquiry.phone || ""}
                onChange={(e) =>
                  setCurrentInquiry({ ...currentInquiry, phone: e.target.value })
                }
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={currentInquiry.email || ""}
                onChange={(e) =>
                  setCurrentInquiry({ ...currentInquiry, email: e.target.value })
                }
                required
              />
            </Form.Group>           
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

    </>
  );
};

export default ManageInquiry;
